<!-- <p>assets works!</p> -->

<div class="main-watch-div">
	<div class="alignRow watch-header">
		<span class="watch-header-label">Watched Assets:&nbsp;</span>

		<span class="watch-header-count" *ngIf="watchedAssets">
			{{watchedAssetsFiltered.length}}/{{watchedAssets.length}}
		</span>

		<span class="toolbar-spacer"></span>

		<div class="location-dropdown">
			<ejs-dropdownlist id="locationDropdown" #locationDropdown [dataSource]='MainLocations'
				placeholder="Select Location" [(ngModel)]="filterQueryParams.Location" [fields]="locationFields"
				(change)="onQueryParameterChange('Location',$event)" [allowFiltering]="true" filterType="contains">
				<ng-template #itemTemplate let-data>
					<div>
						<span>{{ data.Name }}</span>
					</div>
				</ng-template>
			</ejs-dropdownlist>
		</div>
	</div>

	<ejs-splitter #horizontal height="85vh" separatorSize=4 width='100%'>
		<e-panes>
			<e-pane size='30%' min='5%'>
				<ng-template #content>
					<ng-container *ngIf="assetList.length > 0; then ejsListbox"> </ng-container>
				</ng-template>
			</e-pane>

			<e-pane size='70%' min='5%'>
				<ng-template #content>
					<router-outlet></router-outlet>
				</ng-template>
			</e-pane>
		</e-panes>
	</ejs-splitter>
</div>

<ng-template #ejsListbox>
	<mat-form-field appearance="fill">
		<mat-label>Search For an Asset</mat-label>
		<input matInput (keyup)="onQueryParameterChange('Filter', $event)" placeholder="" #input
			[(ngModel)]="filterQueryParams.Filter">
	</mat-form-field>

	<ejs-listbox *ngIf="watchedAssets" #listviewInstance [dataSource]='watchedAssetsFiltered'
		cssClass='e-list-template' [fields]="fields">

		<ng-template #itemTemplate let-dataSource>
			<div class="alignRow watchedAssetsBox"
				[class.selected]="selectedAsset.AssetID == dataSource.AssetID"
				(click)="assetSelected(dataSource)">

				<img class="assetImage"
					src="{{imagePathAssets()}}{{dataSource.AssetID}}?{{dataSource.Modified}}"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
					(click)='viewImage(imagePathAssets() + dataSource.AssetID + "?" + dataSource.Modified)'
					[attr.x-contenttype]="'image/png'" />

				<span>{{dataSource.Name}}</span>
				<span>{{dataSource.Description}}</span>
			</div>
		</ng-template>
	</ejs-listbox>
</ng-template>